import { mapDTO } from '@twistezo/ts-dto-mapper'

import { AdUnitUnfilledRecoveryDTO } from 'features/inventory/api/types/adUnitUnfilledRecoveryDTO'
import { AdUnitUnfilledRecovery } from 'features/inventory/types/adUnitUnfilledRecovery'
import { floatPercentFromDTO } from 'utils/number'

type From = AdUnitUnfilledRecoveryDTO
type To = AdUnitUnfilledRecovery

export const adUnitUnfilledRecoveryFromDTO = (from: From): To =>
  mapDTO<From, To>({ from }).transform(
    ({
      allowMultiformatEnabled,
      baseAdUnitPath,
      customizeBaseAdUnitPathEnabled,
      customizePrebidBehaviour,
      desktopAdDisplaysBeforeRefresh,
      desktopSingleAdViewTime,
      mobileAdDisplaysBeforeRefresh,
      mobileSingleAdViewTime,
      prebidBehaviourType,
      rotatingAdsQty,
      urDesktopAdThreshold,
      urMobileAdThreshold,
    }: From): To => ({
      allowMultiformatEnabled,
      baseAdUnitPath: baseAdUnitPath ?? undefined,
      customizeBaseAdUnitPathEnabled,
      customizePrebidBehaviour,
      desktopAdDisplaysBeforeRefresh,
      desktopSingleAdViewTime,
      mobileAdDisplaysBeforeRefresh,
      mobileSingleAdViewTime,
      prebidBehaviourType,
      rotatingAdsQty,
      urDesktopAdThreshold: floatPercentFromDTO(urDesktopAdThreshold),
      urMobileAdThreshold: floatPercentFromDTO(urMobileAdThreshold),
    }),
  )
